import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axiosInstance from "../../../api/axiosInstance";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Sign from "../../../components/signModal/signModal";
import "../operatorView/operatorView.scss"

const OperatorView = () => {
    const [event, setEvent] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [isSign, setSign] = useState(false);

    const { id } = useParams();

    const fetchData = useCallback(async () => {
        try {
            const [eventRes] = await Promise.all([
                axiosInstance.get(`events/${id}`)
            ]);
            setEvent(eventRes.data[0]);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return isLoading ? (<div className="loading" />) : (
        <div className="operatorView">
            <Helmet>
                <title>Fahrtenplan</title>
            </Helmet>
            <div className="container">
                <div className="header">
                    {isSign
                        ? <CloseIcon onClick={() => setSign(false)} />
                        : <Link to={"/operator"}>
                            <ArrowBackOutlinedIcon />
                        </Link>}
                    <span>{event.description}</span>
                    <div />
                </div>
                {isSign
                    ? <Sign event={event} setSign={setSign} fetchData={fetchData} />
                    : <div className="content">
                        <div className="group">
                            <div className="title">
                                <span>Auftragsdaten</span>
                            </div>
                            <div className="data">
                                <div className="item">
                                    <AccessTimeOutlinedIcon />
                                    <span>{event.startTime} - {event.endTime}</span>
                                </div>
                                <div className="item">
                                    <BusinessOutlinedIcon />
                                    <span>{event.customer}</span>
                                </div>
                                <div className="item">
                                    <LocationOnOutlinedIcon />
                                    <span>{event.location || "Kein Standort festgelegt"}</span>
                                </div>
                                <div className="item">
                                    <LocalShippingOutlinedIcon />
                                    <span>{event.itemKennzeichen}</span>
                                </div>
                                <div className="item">
                                    <ManageAccountsOutlinedIcon />
                                    <span>{event.driverAlias}</span>
                                </div>
                            </div>
                        </div>
                        <div className="group">
                            <div className="title">
                                <span>Notiz</span>
                            </div>
                            <div className="data">
                                <div className="item">
                                    <NotesOutlinedIcon />
                                    <span>{event.note}</span>
                                </div>
                            </div>
                        </div>
                        <div className="group">
                            <div className="title">
                                <span>Auftragspositionen</span>
                            </div>
                            <div className="data">
                                <div className="item">
                                    <label>01</label>
                                    <span>{event.itemAlias}</span>
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>
            {!isSign && <div className="sign">
                <button onClick={() => setSign(true)} className={event.done && "done"}>
                    <EditIcon />
                    <span>{event.done ? "Abgeschlossen" : "Unterschreiben"}</span>
                </button>
            </div>}
        </div>
    )
};

export default OperatorView